<template>
  <div>
    <StoryViewHeader></StoryViewHeader>
    <div class="main_container">
      <div class="container-fluid edit-story-wrapper" :class="selectedNodeType">
        <router-view>
        </router-view>
      </div>
    </div>
  </div>
</template>
<script>
import StoryViewHeader from '../components/v2/story-edit-view/header'
import logicComponent from '../components/v2/story-edit-view/logic'
import sidebar from '../components/profile/sidebar'

export default {
  components: {
    StoryViewHeader,
    logicComponent,
    sidebar
  },
  data () {
    return {
      componentType: null,
      selectedNodeType: '',
    }
  },
  created () {
  },
  watch: {},
  mounted () {
    if (this.$route.params.category) {
      this.componentType = this.$route.params.category
    }
    this.selectedNodeType = this.$store.state.selectedLogic.category ? this.$store.state.selectedLogic.category.toLowerCase() : 'logic'
  },
  methods: {}
}
</script>
<style scoped lang="scss">

/* only wrote css for specific target */
@import '../../external_libs/frame.js/editor/css/dark.css';
@import '../../external_libs/frame.js/editor/css/main.css';


</style>



// WEBPACK FOOTER //
// src/views/globalLogicEditView.vue